<template>
  <div :class="[$style.container, $style.modal]">
    <ModalHeader
      :handleClose="handleCancelAction"
      headerText="Update the source of record for user attributes?"
      :showClose="true"
    />
    <div :class="$style.modalBody">
      <p>
        For the selected attributes of bound users, JumpCloud will override the corresponding
        attribute values in {{ directoryName }} with current JumpCloud data and any
        future changes.
      </p>
      <p>
        For deselected attributes, future changes to JumpCloud will have no impact
        on {{ directoryName }}.
      </p>
      <a
        :href="exportAttributesKbUrl"
        rel="noopener noreferrer"
        target="_blank"
      >Learn More</a>
    </div>
    <ModalFooter
      cancelText="cancel"
      :handleClose="handleCancelAction"
      :handleMainAction="handleMainAction"
      mainActionText="update source of record"
    />
  </div>
</template>

<script>

import ModalEventBus from 'components/Modal/ModalEventBus';
import ModalFooter from 'components/Modal/ModalComponents/ModalFooter.vue';
import ModalHeader from 'components/Modal/ModalComponents/ModalHeader.vue';

export default {
  name: 'ExportAttributeWarningModal',

  components: {
    ModalFooter,
    ModalHeader,
  },

  props: {
    directoryName: {
      type: String,
      required: true,
    },
    exportAttributesKbUrl: {
      type: String,
      required: true,
    },
    handleCancel: {
      type: Function,
      default: () => {},
    },
    handleContinue: {
      type: Function,
      required: true,
    },
  },

  methods: {
    handleCancelAction() {
      this.handleCancel();
      this.handleClose();
    },
    handleClose() {
      ModalEventBus.close();
    },
    handleMainAction() {
      this.handleContinue();
      this.handleClose();
    },
  },
};
</script>

<style module>
.modalBody {
  padding: 5px 35px;
}
</style>
